module.exports = __webpack_public_path__ + "static/media/banner-car-handover.eabf8185.jpg";